module.exports = __webpack_public_path__ + "img/223.79cae583.png";